// extracted by mini-css-extract-plugin
export default {"title":"e1d8cc6257","bld":"_9f7c870c34"};